import React from "react";
import { Link } from "react-router-dom";
import { Lotus } from "@/components/decor/Motifs";

export default function Footer() {
    return (
        <footer
            className="relative bg-cream-50 border-t border-vgold-100 px-6 md:px-12 lg:px-24 py-14"
            data-testid="site-footer"
        >
            <div className="mx-auto max-w-6xl grid grid-cols-1 md:grid-cols-3 gap-10">
                <div>
                    <div className="flex items-center gap-3">
                        <Lotus className="w-8 h-8" />
                        <span className="font-title text-xl text-inkbrown-900 tracking-wide">
                            IYS · SREEMANGAL
                        </span>
                    </div>
                    <p className="mt-4 font-body text-sm text-inkbrown-500 max-w-xs leading-relaxed">
                        ISKCON Youth Services, Sreemangal — carrying the sound of the
                        flute to every classroom and every heart.
                    </p>
                </div>
                <div>
                    <p className="font-body text-xs uppercase tracking-[0.3em] text-maroon-600">
                        Festival
                    </p>
                    <ul className="mt-4 space-y-2 font-body text-inkbrown-900">
                        <li><a href="#highlights" className="hover:text-saffron-600 transition-colors">Highlights</a></li>
                        <li><a href="#schedule" className="hover:text-saffron-600 transition-colors">Schedule</a></li>
                        <li><a href="#register" className="hover:text-saffron-600 transition-colors">Register</a></li>
                    </ul>
                </div>
                <div>
                    <p className="font-body text-xs uppercase tracking-[0.3em] text-maroon-600">
                        Get in touch
                    </p>
                    <p className="mt-4 font-body text-inkbrown-900">
                        Nitai Gaur Temple, Sobujbag,<br />Sreemangal, Bangladesh
                    </p>
                    <div className="mt-4 rounded-2xl bg-gradient-to-br from-saffron-50 to-vgold-50 border border-vgold-200 px-4 py-3">
                        <p className="font-body text-[10px] uppercase tracking-[0.3em] text-maroon-600">
                            Emergency Contact Only
                        </p>
                        <a
                            href="tel:+8801721607559"
                            data-testid="footer-emergency-contact"
                            className="mt-1 inline-block font-heading text-lg text-inkbrown-900 font-semibold hover:text-saffron-600 transition-colors"
                        >
                            +880 1721-607559
                        </a>
                    </div>
                    <Link
                        to="/admin/login"
                        data-testid="footer-admin-link"
                        className="mt-6 inline-block font-body text-xs uppercase tracking-[0.3em] text-inkbrown-500 hover:text-saffron-600 transition-colors"
                    >
                        Admin Access →
                    </Link>
                </div>
            </div>
            <div className="mx-auto max-w-6xl mt-12 pt-6 border-t border-vgold-100 flex flex-col md:flex-row items-center justify-between gap-2">
                <p className="font-body text-xs text-inkbrown-500">
                    © 2026 IYS Sreemangal · Hare Krishna
                </p>
                <p className="font-heading italic text-sm text-inkbrown-500">
                    “Chant, dance, feast — and be free.”
                </p>
            </div>
        </footer>
    );
}
